import { useEffect } from 'react';

import SalesStatementIntermediationFilters from '~/components/molecules/SalesStatement/SalesStatementIntermediationFilters';
import SalesStatementIntermediationHeader from '~/components/molecules/SalesStatement/SalesStatementIntermediationHeader';

import { PageContainer } from '~/components/bosons/PageContainer.styled';
import SalesStatementCardsPanel from '~/components/molecules/SalesStatement/SalesStatementCardsPanel';
import SalesStatementIntermediationSummary from '~/components/molecules/SalesStatement/SalesStatementIntermediationSummary';
import SalesStatementIntermediationTable from '~/components/molecules/SalesStatement/SalesStatementIntermediationTable';
import useSaleStatementByTypeStore from '~/zustand/salesStatement/useSalesStatementByTypeStore';

export default function Intermediation() {
  const resetStates = useSaleStatementByTypeStore(state => state.resetStatesToDefault);

  useEffect(() => {
    return () => {
      function resetStatesWhenCloseTab() {
        resetStates();
      }
      resetStatesWhenCloseTab();
    };
  }, [resetStates]);

  return (
    <PageContainer>
      <SalesStatementIntermediationHeader />
      <SalesStatementIntermediationFilters />
      <SalesStatementCardsPanel />
      <SalesStatementIntermediationTable />
      <SalesStatementIntermediationSummary />
    </PageContainer>
  );
}
